import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-origami',
  templateUrl: './page-origami.component.html',
  styleUrls: ['./page-origami.component.css']
})
export class PageOrigamiComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
